import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import {
  getActiveExhibitionData,
  clearActiveExhibition,
  type StoredExhibition,
} from "../../utils/exhibitionContext";

interface ExhibitionState {
  active: StoredExhibition | null;
}

// Hydrate from localStorage so a page refresh preserves the selection
const initialState: ExhibitionState = {
  active: getActiveExhibitionData(),
};

const exhibitionSlice = createSlice({
  name: "exhibition",
  initialState,
  reducers: {
    /** Set the active exhibition in Redux state only.
     *  Caller is responsible for persisting to localStorage via setActiveExhibition(). */
    setExhibition(state, action: PayloadAction<StoredExhibition>) {
      state.active = action.payload;
    },

    /** Clear the active exhibition (e.g. on logout). */
    clearExhibition(state) {
      state.active = null;
      clearActiveExhibition();
    },

    /**
     * Sync the Redux state with whatever is currently in localStorage.
     * Useful after a page refresh or a direct localStorage write.
     */
    syncFromStorage(state) {
      state.active = getActiveExhibitionData();
    },
  },
});

export const { setExhibition, clearExhibition, syncFromStorage } =
  exhibitionSlice.actions;

export default exhibitionSlice.reducer;